import { render, staticRenderFns } from "./availability-item.vue?vue&type=template&id=22eba362&scoped=true&lang=html"
import script from "./availability-item.vue?vue&type=script&lang=js"
export * from "./availability-item.vue?vue&type=script&lang=js"
import style0 from "./availability-item.vue?vue&type=style&index=0&id=22eba362&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22eba362",
  null
  
)

export default component.exports